import { useMemo } from "react";
import { addChatParticipantInfo } from "../../../../../utils/chat-util";
import { CommunityChatBox } from "../CommunityChatBox";
import { CommunityChatList } from "../CommunityChatList";
import PropTypes from "prop-types";
import { EmptyChatBox } from "../EmptyChatBox";

export const CommunityChatMounted = ({
  locals,
  api,
  conversations,
  setConversations,
  selectedConversation,
  setSelectedConversation,
  chatbox,
  chatboxEl,
  mobileChatOpened,
  setMobileChatOpened,
}) => {
  const { activeSubscribersList: subscribers = [] } = locals;
  const {
    readChannels = [],
    readDirects = [],
    unreadChats = [],
  } = conversations;
  const conversationsWithParticipants = useMemo(() => {
    return {
      readChannels,
      readDirects: addChatParticipantInfo(readDirects, subscribers),
      unreadChats: addChatParticipantInfo(unreadChats, subscribers),
    };
  }, [readChannels, readDirects, unreadChats, subscribers]);
  const allChatsEmpty = [readChannels, readDirects, unreadChats].every(
    (chatArray) => chatArray.length === 0
  );

  return (
    <>
      <CommunityChatList
        locals={locals}
        api={api}
        chatbox={chatbox}
        conversations={conversationsWithParticipants}
        setConversations={setConversations}
        selectedConversation={selectedConversation}
        setSelectedConversation={setSelectedConversation}
        setMobileChatOpened={setMobileChatOpened}
      />
      {allChatsEmpty ? (
        <EmptyChatBox />
      ) : (
        <CommunityChatBox
          locals={locals}
          chatboxEl={chatboxEl}
          mobileChatOpened={mobileChatOpened}
          setMobileChatOpened={setMobileChatOpened}
        />
      )}
    </>
  );
};

CommunityChatMounted.propTypes = {
  locals: PropTypes.object,
  api: PropTypes.any,
  conversations: PropTypes.object,
  setConversations: PropTypes.func,
  selectedConversation: PropTypes.string,
  setSelectedConversation: PropTypes.func,
  chatbox: PropTypes.any,
  chatboxEl: PropTypes.any,
  mobileChatOpened: PropTypes.bool,
  setMobileChatOpened: PropTypes.func,
};
